import * as sites from 'goodeggs-sites';
import NamedError from 'goodeggs-named-error';

function getFinishedGoodsPage({$http, settings, producerId, cursor, edges}) {
  return $http({
    method: 'POST',
    url: `${sites.getUrl('catalog-api', settings)}/graph`,
    data: {
      operationName: 'getFinishedGoodsByProducerId',
      variables: {producerId, cursor},
      query: `\
        query getFinishedGoodsByProducerId($producerId: String!, $cursor: String) {
          finishedGoods(producerId: $producerId,marketStatusValues: ["hidden", "shoppable"], after: $cursor) {
            pageInfo {
              hasNextPage
              hasPreviousPage
              endCursor
            }
            edges {
              node {
                orzoProductId
                customerFacingName
                customerFacingUnit
                assortmentType {
                  id
                }
              }
            }
          }
        }\
        `,
    },
  }).then((result) => {
    const graphQLResponse = result.data;

    if (graphQLResponse.errors != null) {
      throw new NamedError({
        message: 'Error response from Catalog API for getFinishedGoodsByProducerId query',
        data: {result},
      });
    }
    if (graphQLResponse.data == null || graphQLResponse.data.finishedGoods == null) {
      throw new NamedError({
        message: 'Unexpected response from Catalog API for getFinishedGoodsByProducerId query',
        data: {result},
      });
    }

    const response = graphQLResponse.data?.finishedGoods;

    const finishedGoodEdges = [...edges, ...response.edges];

    if (response.pageInfo.hasNextPage)
      return getFinishedGoodsPage({
        $http,
        settings,
        producerId,
        cursor: response.pageInfo.endCursor,
        edges: finishedGoodEdges,
      });

    return finishedGoodEdges;
  });
}

export default __filename;
angular.module(__filename, []).factory(
  'Product',
  ngInject(function($http, settings) {
    return {
      getFinishedGoodsByProducerId: (producerId) =>
        getFinishedGoodsPage({$http, settings, producerId, cursor: null, edges: []})
          .then((response) => {
            return response.map(({node}) => ({
              _id: node.orzoProductId,
              name: node.customerFacingName,
              unit: node.customerFacingUnit,
              productType: node.assortmentType.id,
              storageType: 'dry',
            }));
          })
          .then((response) => {
            console.log({response: response.length});

            return response;
          }),
    };
  }),
);
